var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { fetchPreMatchMenu as fetchMenuAction } from '../../../actions/creators/lines';
import { getMatchResults as getMatchResultsAction, clearMatchResult as clearMatchResultAction } from '../../../actions/creators/matchResults';
import { sportSortFunc } from '../../../rendering-commons/Sorting';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import DateRange from '../../shared/DateRange.jsx';
import Date from '../../shared/Date.jsx';
import Sport from './Sports';
import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import Loader from '../../Loader';
var messages = defineMessages({
    history_bets_type_today: {
        id: 'history_bets_type_today',
        defaultMessage: 'Today'
    },
    history_bets_type_yesterday: {
        id: 'history_bets_type_yesterday',
        defaultMessage: 'Yesterday'
    },
    history_bets_type_on_date: {
        id: 'history_bets_type_on_date',
        defaultMessage: 'On Date'
    },
    history_bets_type_for_period: {
        id: 'history_bets_type_for_period',
        defaultMessage: 'For Period'
    },
    results_tab_message: {
        id: 'results_tab_message',
        defineMessages: 'Choose a period and sport'
    }
});
var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            filterItems: [
                { msg: 'history_bets_type_today', value: 'today' },
                { msg: 'history_bets_type_yesterday', value: 'yesterday' },
                { msg: 'history_bets_type_on_date', value: 'date' },
                { msg: 'history_bets_type_for_period', value: 'period' },
            ],
            activeTab: 'sports',
            filterType: 'today',
            showDateRangePicker: false,
            showDatePicker: false,
            dateFrom: moment().startOf('day'),
            dateTo: moment().utc().endOf('day'),
            sportId: 0
        };
        _this.onTabClick = function (activeTab) {
            _this.props.clearMatchResultAction();
            _this.setState({
                activeTab: activeTab
            });
        };
        _this.onDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day'),
                dateTo: moment(date).endOf('day'),
            });
        };
        _this.startDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day')
            });
        };
        _this.endDateChange = function (date) {
            _this.setState({
                dateTo: moment(date).endOf('day')
            });
        };
        _this.onDateSelectHandle = function (e) {
            var period = e.target.value;
            _this.setState({
                filterType: period
            });
            switch (period) {
                case 'period':
                    _this.setState({
                        showDateRangePicker: true,
                        showDatePicker: false
                    });
                    break;
                case 'date':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: true
                    });
                    break;
                case 'today':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false,
                        dateFrom: moment().startOf('day'),
                        dateTo: moment().utc().endOf('day'),
                    });
                    break;
                case 'yesterday':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false,
                        dateFrom: moment().subtract(1, 'day').startOf('day'),
                        dateTo: moment().subtract(1, 'day').endOf('day'),
                    });
                    break;
                default:
                    _this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'), 'active');
            }
            _this.props.clearMatchResultAction();
        };
        _this.onSportChange = function (e) {
            _this.setState({
                sportId: +e.target.value
            });
        };
        _this.onSubmit = function () {
            var languageId = _this.props.languageId;
            var _a = _this.state, dateFrom = _a.dateFrom, dateTo = _a.dateTo, activeTab = _a.activeTab, sportId = _a.sportId;
            var isLive = activeTab === 'live';
            var startDate = moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss');
            var finishDate = moment(dateTo).format('YYYY-MM-DDTHH:mm:ss');
            var data = {
                startDate: startDate,
                finishDate: finishDate,
                isLive: isLive,
                languageId: languageId
            };
            if (sportId !== 0) {
                data.sports = [sportId];
            }
            _this.props.getMatchResultsAction(data);
        };
        return _this;
    }
    Results.prototype.componentDidMount = function () {
        var languageId = this.props.languageId;
        this.props.fetchMenuAction({ languageId: languageId });
    };
    Results.prototype.render = function () {
        var _this = this;
        var _a = this.props, sportsMenu = _a.sportsMenu, sports = _a.sports, leagues = _a.leagues, intl = _a.intl, fetching = _a.fetching;
        var _b = this.state, activeTab = _b.activeTab, filterType = _b.filterType, filterItems = _b.filterItems;
        var sportsOption = [];
        sportsOption.push(_jsx("option", __assign({ value: 0 }, { children: intl.formatMessage({ id: 'grid.all_sports' }) }), 0));
        if (sportsMenu !== undefined) {
            sportsMenu.sort(sportSortFunc).map(function (sport) {
                sportsOption.push(_jsx("option", __assign({ value: sport.get('id') }, { children: sport.get('name') }), sport.get('id')));
            });
        }
        var resultsActive = activeTab === 'sports' ? 'active' : '';
        var resultsLiveActive = activeTab === 'live' ? 'active' : '';
        var showDatePicker = filterType === 'period' || filterType === 'date';
        var dateRangeProps = {
            endDateChange: this.endDateChange,
            startDateChange: this.startDateChange,
            languageId: this.props.languageId
        };
        var renderSports = [];
        if (sports !== undefined) {
            sports.sort(sportSortFunc).map(function (sport) {
                renderSports.push(_jsx(Sport, { sport: sport, leagues: leagues, section: 'results' }, sport.get('id')));
            });
        }
        return (_jsxs("div", __assign({ className: 'results_content' }, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: ["\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0441\u043F\u043E\u0440\u0442\u0438\u0432\u043D\u044B\u0445 \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0438 \u0441\u043E\u0440\u0435\u0432\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u043E\u0442 \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u0430 ", window.COMPANY_NAME] }), _jsx("meta", { name: 'description', content: '\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u044E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043C\u0430\u0442\u0447\u0435\u0439 \u043F\u043E \u0444\u0443\u0442\u0431\u043E\u043B\u0443, \u0442\u0435\u043D\u043D\u0438\u0441\u0443, \u0431\u0430\u0441\u043A\u0435\u0442\u0431\u043E\u043B\u0443, \u0432\u043E\u043B\u0435\u0439\u0431\u043E\u043B\u0443, \u0445\u043E\u043A\u043A\u0435\u044E, \u0431\u043E\u043A\u0441\u0443, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0441\u043E\u0440\u0435\u0432\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u043F\u043E \u0431\u043E\u0440\u044C\u0431\u0435, \u043F\u043B\u0430\u0432\u0430\u043D\u0438\u044E, \u0444\u043E\u0440\u043C\u0443\u043B\u0435-1...' })] }), _jsx("div", __assign({ className: 'tabmenu' }, { children: _jsxs("ul", __assign({ className: 'tabs', role: 'tablist' }, { children: [_jsx("li", __assign({ className: resultsActive }, { children: _jsx("a", __assign({ href: '#', onClick: function () { return _this.onTabClick('sports'); } }, { children: intl.formatMessage({ id: 'info.results' }) })) })), _jsx("li", __assign({ className: resultsLiveActive }, { children: _jsx("a", __assign({ href: '#', onClick: function () { return _this.onTabClick('live'); } }, { children: intl.formatMessage({ id: 'info.results_live' }) })) }))] })) })), _jsxs("div", __assign({ className: 'block blc_result' }, { children: [_jsx("div", __assign({ className: 'filter' }, { children: _jsxs("div", __assign({ className: 'results-form', id: 'results-form' }, { children: [_jsx("div", __assign({ className: 'rows' }, { children: _jsx("div", __assign({ className: 'history__filter' }, { children: filterItems.map(function (item) {
                                                var cls = item.value === filterType ? 'history__filter__item history__filter__item--active' : 'history__filter__item';
                                                return (_createElement(FormattedMessage, __assign({}, messages[item.msg], { key: item.value }), function (message) { return _jsx("button", __assign({ value: item.value, className: cls, onClick: _this.onDateSelectHandle }, { children: message })); }));
                                            }) })) })), showDatePicker && _jsx("div", __assign({ className: 'rows' }, { children: _jsxs("div", __assign({ className: 'datapicker-content' }, { children: [filterType === 'period' && _jsx(DateRange, __assign({}, dateRangeProps)), filterType === 'date' && _jsx(Date, { onDateChange: this.onDateChange, languageId: this.props.languageId })] })) })), _jsx("div", __assign({ className: 'rows' }, { children: _jsxs("div", __assign({ className: 'cols' }, { children: [_jsx("div", __assign({ className: 'select' }, { children: _jsx("select", __assign({ onChange: this.onSportChange }, { children: sportsOption })) })), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ id: 'results-update', onClick: this.onSubmit }, { children: intl.formatMessage({ id: 'info.show' }) })) }))] })) }))] })) })), _jsx("div", __assign({ className: 'tab-content' }, { children: _jsx("div", __assign({ className: 'tab-pane active' }, { children: _jsxs("div", __assign({ id: 'results' }, { children: [fetching && _jsx(Loader, {}), renderSports.length > 0 ? renderSports :
                                            _jsx("div", __assign({ className: 'results-tab-message' }, { children: _jsx(FormattedMessage, __assign({}, messages.results_tab_message)) }))] })) })) }))] }))] })));
    };
    Results.propTypes = {
        sportsMenu: PropTypes.object.isRequired,
        intl: PropTypes.object.isRequired,
        clearMatchResultAction: PropTypes.func.isRequired,
        getMatchResultsAction: PropTypes.func.isRequired,
        fetchMenuAction: PropTypes.func.isRequired,
        languageId: PropTypes.number.isRequired,
        fetching: PropTypes.any
    };
    return Results;
}(React.Component));
var mapStateToProps = function (state) { return ({
    sportsMenu: state.application.getIn(['menu', 'sports']),
    sports: state.application.getIn(['results', 'sports']),
    leagues: state.application.getIn(['results', 'leagues']),
    languageId: state.application.get('languageId'),
    fetching: state.application.getIn(['results', 'fetching'])
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    fetchMenuAction: fetchMenuAction,
    getMatchResultsAction: getMatchResultsAction,
    clearMatchResultAction: clearMatchResultAction
}, dispatch); };
Results = connect(mapStateToProps, mapDispatchToProps)(Results);
export default injectIntl(Results);



// WEBPACK FOOTER //
// ./src/components/info/results/Results.jsx